export default __webpack_public_path__ + "static/media/blur-investors.fb46b45d.webp";